module.exports = __webpack_public_path__ + "static/conversations-with-friends-e62962f1e902d7af0c191038bbcc8939.jpg";